import Vue from 'vue';
import Config from '@/util/config';

Vue.directive('configIf', {
    inserted(el, binding) {
        Config.isConfigured(binding.value).then(function (is) {
            if (!is) {
                el.parentNode.removeChild(el);
            }
        })
    }
});